export function generaAlertAISala({

  tavolo,
  aiSalaConfig,
  ordini = [],
  chiamateServizio = []

}) {

  const alerts = [];

  if (
    !aiSalaConfig?.supervisoreSala
  ) {
    return alerts;
  }

  /* ========================================
     🚨 TAVOLO INATTIVO
  ======================================== */

  if (
    aiSalaConfig.supervisoreSala
      ?.tavoloInattivo?.enabled
  ) {

    const timestampAttivazione =
      tavolo?.creatoIl?.seconds ||
      tavolo?.timestamp?.seconds ||
      tavolo?.ultimoPing?.seconds;


    if (
      timestampAttivazione &&
      tavolo?.attivo &&
      !tavolo?.impegnato
    ) {

      const minutiPassati =
        (
          Date.now() -
          (timestampAttivazione * 1000)
        ) / 60000;

      if (
        minutiPassati >=
        (
          aiSalaConfig?.supervisoreSala
            ?.tavoloInattivo?.minuti || 15
        )
      ) {

        alerts.push({

          tipo:
            "tavolo_inattivo",

          priorita:
            "alta",

          testo:
            `Tavolo ${tavolo.numero} inattivo da ${Math.floor(minutiPassati)} min`

        });

      }

    }

  }

    /* ========================================
     🍽️ TAVOLO SERVITO DA X MINUTI
  ======================================== */

  if (
    aiSalaConfig?.supervisoreSala
      ?.tavoloServitoDa?.enabled
  ) {

    const ordiniServiti = ordini.filter(o => {
      if (!o.servitoCompletamenteAt?.seconds) {
        return false;
      }

      return (o.items || []).length > 0 &&
        (o.items || []).every(
          item =>
            String(item.stato || "").toLowerCase() === "servito"
        );
    });

    if (ordiniServiti.length > 0) {
      const ultimoOrdineServito = ordiniServiti
        .sort(
          (a, b) =>
            b.servitoCompletamenteAt.seconds -
            a.servitoCompletamenteAt.seconds
        )[0];

      const minutiPassati =
        (
          Date.now() -
          ultimoOrdineServito.servitoCompletamenteAt.seconds * 1000
        ) / 60000;

      const minutiSoglia =
        Number(
          aiSalaConfig?.supervisoreSala
            ?.tavoloServitoDa?.minuti
        ) || 20;

      if (minutiPassati >= minutiSoglia) {
        alerts.push({
          tipo: "tavolo_servito",
          priorita: "media",
          testo: `Tavolo ${tavolo.numero} servito da ${Math.floor(minutiPassati)} min`
        });
      }
    }
  }

  return alerts;

}